export const STORY_FONTS = [
  { key: "heebo", label: "חיבו", family: '"Heebo", sans-serif' },
  { key: "rubik", label: "רוביק", family: '"Rubik", sans-serif' },
  { key: "assistant", label: "אסיסטנט", family: '"Assistant", sans-serif' },
  { key: "varela", label: "עגול", family: '"Varela Round", sans-serif' },
  { key: "fredoka", label: "כיפי", family: '"Fredoka", sans-serif' },
  { key: "alef", label: "אלף", family: '"Alef", sans-serif' },
  { key: "frank", label: "פרנק", family: '"Frank Ruhl Libre", serif' },
  { key: "secular", label: "תצוגה", family: '"Secular One", sans-serif' },
  { key: "karantina", label: "חזק", family: '"Karantina", sans-serif' },
  { key: "suez", label: "סואץ", family: '"Suez One", serif' },
];

const FONT_MAP = Object.fromEntries(STORY_FONTS.map((font) => [font.key, font]));

export function resolveStoryFont(key) {
  return FONT_MAP[key]?.family || FONT_MAP.heebo.family;
}

export function sanitizeStoryFont(key) {
  return FONT_MAP[key] ? key : "heebo";
}
